exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".panel-heading h4[data-v-1a7610a4]{text-transform:uppercase;font-weight:500}[dir=ltr] .panel-heading h4[data-v-1a7610a4]{margin-left:-20px;padding-left:10px}[dir=rtl] .panel-heading h4[data-v-1a7610a4]{margin-right:-20px;padding-right:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1a7610a4","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/profit.vue
// module id = 1214
// module chunks = 0